import { INVALID_VALIDATOR } from 'constants/errors';
import { ListModel, ValidateErrorContext } from 'forms/shared/types';
import { EmptyList } from 'forms/shared/models';
import { BaseCustomValidator } from '../types';
import { EmptyBranchInstance } from '../../models/branch/instance';
import listModelValidator from '../../models/list';

const accordionBaseValidator: BaseCustomValidator<ListModel<{}>> = (validateModel) => (
  value,
  options,
  key,
  attributes,
  globalOptions
) => {
  const { validator, itemsValidator } = options;
  if (!validator) { return INVALID_VALIDATOR; }

  let errors: ValidateErrorContext[] = [];

  const { items, branch } = { ...EmptyList<{}>(), ...value };

  const listModelErrors = validateModel(
    {
      branch: {
        ...EmptyBranchInstance,
        ...branch,
      },
      items: [...items],
    },
    listModelValidator,
    options
  );

  if (typeof listModelErrors !== 'boolean') { errors = [...listModelErrors]; }

  let itemsErrors: ValidateErrorContext[] = [];

  items.forEach((item, index) => {
    const { Item } = item;
    const itemErrors = validateModel({ ...Item, $index: index }, validator, {
      ...globalOptions,
      ...options,
      // This allows the validator to have access to the parent attributes for
      // further validation.
      parentAttributes: attributes,
    });
    if (typeof itemErrors !== 'boolean') { itemsErrors = itemsErrors.concat(itemErrors.map((e) => e)); }
  });

  if (itemsErrors.length) { errors = [...errors, ...itemsErrors]; }

  // Optional function to test against all of the items
  if (itemsValidator) {
    const itemsValidatorErrors = itemsValidator(items);
    if (itemsValidatorErrors) { errors.push(itemsValidatorErrors); }
  }

  if (errors.length) { return errors; }

  return null;
};

export default accordionBaseValidator;
